module.exports = __webpack_public_path__ + "img/artboard0.9f5f5dc9.png";